import React, { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// @ts-ignore
import { Base64 } from 'js-base64';
import { KitLoader } from '@omni/kit/components';
import Routes from '../../../messaging/web/navigation/Routes';
import { View } from 'react-native';
import { savePendingCommandToDevice } from '../../utilities/mobileStorage';

interface AcceptInvitationScreenProps {
  isAuthenticated: boolean;
  isAuthReady: boolean;
}

export default function AcceptInvitationScreen({
  isAuthenticated,
  isAuthReady,
}: AcceptInvitationScreenProps) {
  const history = useHistory();
  const params = useParams();

  // Invite payload is a base64 encoded JSON which contains all info required to
  // accept an invite
  // @ts-ignore
  const invitePayload: string | undefined = params.invitePayload;

  const processInvite = useCallback(() => {
    if (!invitePayload) {
      return;
    }

    const decodedPayload = decodeURIComponent(invitePayload);
    const inviteObject = JSON.parse(Base64.decode(decodedPayload));
    savePendingCommandToDevice(inviteObject.moduleCommand);
    if (isAuthReady && !isAuthenticated) {
      // @ts-ignore
      history.push(Routes.login(params.appKey));
    } else if (isAuthReady && isAuthenticated) {
      // @ts-ignore
      history.push(Routes.channels(params.appKey));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitePayload, isAuthReady, isAuthenticated]);

  useEffect(() => {
    processInvite();
  }, [processInvite]);

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <KitLoader />
    </View>
  );
}
